var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Orderdetails_minibox"},[_c('h2',[_vm._v(_vm._s(_vm.$t("sabre.booking.order-detail-box.flight-details")))]),_c('order-detail-mini-one-box',{attrs:{"data":_vm.flight.legs[0]}}),(!_vm.isOneWay)?_c('order-detail-mini-one-box',{attrs:{"isBack":true,"data":_vm.flight.legs[1]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }